import {useLightbox} from 'platform/lightbox';

import {isNil, sortBy} from 'ramda';

import {useGetPromoPhotoForVehicleQuery} from '@dms/api/core';
import {useGetVehicleCoverPhotoQuery} from '@dms/api/sales';
import {VehiclePromoPhotoResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {useDmsLightboxActionsFactory} from './useDmsLightboxActionsFactory';
import {useVehicleCoverPhoto} from './useVehicleCoverPhoto';

export const useVehicleHeaderImage = (vehicleId: string | Nullish) => {
  const {photos, coverPhoto} = useVehicleCoverPhoto(vehicleId);
  const {data: vehicleCoverPhoto} = useGetVehicleCoverPhotoQuery(
    {vehicleId: vehicleId ?? ''},
    {skip: isNil(vehicleId)}
  );

  const {data: vehiclePromoPhotos} = useGetPromoPhotoForVehicleQuery(
    {
      vehicleId: vehicleId ?? '',
    },
    {
      skip: isNil(vehicleId),
    }
  );

  const [lightboxControls, {onOpen}] = useLightbox('vehicleHeader');
  const lightboxActionsFactory = useDmsLightboxActionsFactory();

  const sortedPhotos = sortBy(
    (item: VehiclePromoPhotoResponseBody) => item.position,
    vehiclePromoPhotos ?? []
  );

  const allPhotos = [...photos, ...sortedPhotos];

  const vehicleImages = lightboxActionsFactory.addFullActions(
    allPhotos.map((image) => ({
      id: image.id,
      url: image.url.replace('resize', 'get'),
      resizeUrl: image.url,
      name: image.fileId,
    }))
  );

  const onCoverPhotoClick = () => {
    const coverPhotoFileId = vehicleCoverPhoto?.fileId ?? coverPhoto?.fileId;
    const index = vehicleImages?.findIndex((slide) => slide.name === coverPhotoFileId);
    onOpen(index ?? 0);
  };

  return [
    lightboxControls,
    vehicleCoverPhoto?.uri ?? coverPhoto?.url,
    onCoverPhotoClick,
    vehicleImages,
    lightboxActionsFactory.photoDownloadSizeDialog,
  ] as const;
};
